package com.dignicate.web.style

import com.dignicate.web.css.ColorValue
import com.dignicate.web.css.FlexDirection
import com.dignicate.web.css.JustifyContent
import com.dignicate.web.css.color
import com.dignicate.web.css.flexDirection
import com.dignicate.web.css.fontWeight
import com.dignicate.web.css.justifyContent
import com.dignicate.web.css.lineHeightUnitless
import com.dignicate.web.css.marginLeftAuto
import com.dignicate.web.css.marginRightAuto
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.style
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width

object HeroStyles : StyleSheet() {
    val section by style {
        // keep background transparent so existing hero background is preserved
        padding(64.px, 0.px)
        minHeight(70.vh)
    }

    val inner by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        maxWidth(1200.px)
        margin(0.px)
        marginLeftAuto()
        marginRightAuto()
        padding(0.px, 20.px)
        alignItems(AlignItems.Center)
    }

    val textColumn by style {
        width(60.percent)
        padding(0.px, 12.px)
    }

    val visualColumn by style {
        width(40.percent)
        padding(0.px, 12.px)
        // subtle placeholder background
        property(
            "background-color",
            "rgba(255,255,255,0.03)"
        )
        borderRadius(12.px)
        minHeight(280.px)
    }

    val title by style {
        fontSize(36.px)
        lineHeightUnitless(1.1)
        fontWeight(700)
        margin(0.px, 0.px, 12.px, 0.px)
    }

    val subtitle by style {
        fontSize(18.px)
        lineHeightUnitless(1.6)
        margin(0.px, 0.px, 20.px, 0.px)
        color(ColorValue.Rgba(0, 0, 0, 0.7))
    }

    // Mobile adjustments (simple)
    val mobileInner by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    val mobileTitle by style {
        fontSize(24.px)
    }
}
